import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

type OverridesState = {
  overrides: Record<string, boolean>
  setOverride: (flagKey: string, value: boolean) => void
  clearOverride: (flagKey: string) => void
  clearAll: () => void
}

/**
 * Session-only feature flag overrides. Lets a Hakio user flip a boolean flag locally for the
 * current browser tab, on top of whichever flag system is active, without affecting other users.
 * Backed by sessionStorage so it survives reloads within the same tab but resets
 * when the tab closes.
 */
export const useFeatureFlagOverridesStore = create<OverridesState>()(
  persist(
    (set) => ({
      overrides: {},
      setOverride: (flagKey, value) =>
        set((state) => ({ overrides: { ...state.overrides, [flagKey]: value } })),
      clearOverride: (flagKey) =>
        set((state) => {
          const next = { ...state.overrides }
          delete next[flagKey]
          return { overrides: next }
        }),
      clearAll: () => set({ overrides: {} }),
    }),
    {
      name: "hakio.featureFlagOverrides",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
